var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 99,
    viewBox: "0 0 31 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_240_1665",
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -1,
    width: 34,
    height: 101,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -2,
    y: -1,
    width: 34,
    height: 101
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.35 15L2.8 24.45L0.1 21L23.35 -3.93391e-06H30.85V99H17.35V15Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.35 15H18.35V13.1581L16.8053 14.1614L17.35 15ZM2.8 24.45L2.0125 25.0663L2.5768 25.7874L3.34468 25.2886L2.8 24.45ZM0.1 21L-0.570286 20.2579L-1.2618 20.8825L-0.687505 21.6163L0.1 21ZM23.35 -3.8147e-06V-1H22.9652L22.6797 -0.742107L23.35 -3.8147e-06ZM30.85 -3.8147e-06H31.85V-1H30.85V-3.8147e-06ZM30.85 99V100H31.85V99H30.85ZM17.35 99H16.35V100H17.35V99ZM16.8053 14.1614L2.25532 23.6114L3.34468 25.2886L17.8947 15.8386L16.8053 14.1614ZM3.58751 23.8337L0.887506 20.3837L-0.687505 21.6163L2.0125 25.0663L3.58751 23.8337ZM0.770286 21.7421L24.0203 0.7421L22.6797 -0.742107L-0.570286 20.2579L0.770286 21.7421ZM23.35 0.999996H30.85V-1H23.35V0.999996ZM29.85 -3.8147e-06V99H31.85V-3.8147e-06H29.85ZM30.85 98H17.35V100H30.85V98ZM18.35 99V15H16.35V99H18.35Z",
    fill: "#A9A7A7",
    mask: "url(#path-1-outside-1_240_1665)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.8ffba5deaf0ad3368a2aaaf023e227e4.svg";
export { ForwardRef as ReactComponent };